<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/newsList' }">政策法规</el-breadcrumb-item>
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容区域    -->
    <div class="card-box">
      <div class="news-detail_content">
        <div class="news-detail-head">
          <div class="news-detail_title">国家市场监督管理总局职能配置、内设机构和人员编制规定</div>
          <div class="news-detail_info">
            <span>时间：2023-06-30 16:17:54</span>
            <span>作者：张智斌</span>
            <span>来源：包头市场监督管理局</span>
          </div>
        </div>
        <p>
            根据《国家市场监督管理总局职能配置、内设机构和人员编制规定》，国家市场监督管理总局是国务院直属机构，为正部级。
        </p>
        <p>
            主要职责：
        </p>
        <p>
            （一）负责市场综合监督管理。起草市场监督管理有关法律法规草案，制定有关规章、政策、标准，组织实施质量强国战略、食品安全战略和标准化战略，拟订并组织实施有关规划，规范和维护市场秩序，营造诚实守信、公平竞争的市场环境。
        </p>
        <p>
            （二）负责市场主体统一登记注册。指导各类企业、农民专业合作社和从事经营活动的单位、个体工商户以及外国（地区）企业常驻代表机构等市场主体的登记注册工作。建立市场主体信息公示和共享机制，依法公示和共享有关信息，加强信用监管，推动市场主体信用体系建设。
        </p>
        <p>
            （三）负责组织和指导市场监管综合执法工作。指导地方市场监管综合执法队伍整合和建设，推动实行统一的市场监管。组织查处重大违法案件。规范市场监管行政执法行为。
        </p>
        <p>
            （四）负责反垄断统一执法。统筹推进竞争政策实施，指导实施公平竞争审查制度。依法对经营者集中行为进行反垄断审查，负责垄断协议、滥用市场支配地位和滥用行政权力排除、限制竞争等反垄断执法工作。指导企业在国外的反垄断应诉工作。承担国务院反垄断委员会日常工作。
        </p>
        <p>
            （五）负责监督管理市场秩序。依法监督管理市场交易、网络商品交易及有关服务的行为。组织指导查处价格收费违法违规、不正当竞争、违法直销、传销、侵犯商标专利知识产权和制售假冒伪劣行为。指导广告业发展，监督管理广告活动。指导查处无照生产经营和相关无证生产经营行为。指导中国消费者协会开展消费维权工作。
        </p>
        <p>
            （六）负责宏观质量管理。拟订并实施质量发展的制度措施。统筹国家质量基础设施建设与应用，会同有关部门组织实施重大工程设备质量监理制度，组织重大质量事故调查，建立并统一实施缺陷产品召回制度，监督管理产品防伪工作。
        </p>
        <p>
            （七）负责产品质量安全监督管理。管理产品质量安全风险监控、国家监督抽查工作。建立并组织实施质量分级制度、质量安全追溯制度。指导工业产品生产许可管理。负责纤维质量监督工作。
        </p>
        <p>
            （八）负责特种设备安全监督管理。综合管理特种设备安全监察、监督工作，监督检查高耗能特种设备节能标准和锅炉环境保护标准的执行情况。
        </p>
        <p>
            （九）负责食品安全监督管理综合协调。组织制定食品安全重大政策并组织实施。负责食品安全应急体系建设，组织指导重大食品安全事件应急处置和调查处理工作。建立健全食品安全重要信息直报制度。承担国务院食品安全委员会日常工作。
        </p>
        <p>
            （十）负责食品安全监督管理。建立覆盖食品生产、流通、消费全过程的监督检查制度和隐患排查治理机制并组织实施，防范区域性、系统性食品安全风险。推动建立食品生产经营者落实主体责任的机制，健全食品安全追溯体系。组织开展食品安全监督抽检、风险监测、核查处置和风险预警、风险交流工作。组织实施特殊食品注册、备案和监督管理。
        </p>
        <p>
            （十一）负责统一管理计量工作。推行法定计量单位和国家计量制度，管理计量器具及量值传递和比对工作。规范、监督商品量和市场计量行为。
        </p>
        <p>
            （十二）负责统一管理标准化工作。依法承担强制性国家标准的立项、编号、对外通报和授权批准发布工作。制定推荐性国家标准。依法协调指导和监督行业标准、地方标准、团体标准制定工作。组织开展标准化国际合作和参与制定、采用国际标准工作。
        </p>
        <p>
            （十三）负责统一管理检验检测工作。推进检验检测机构改革，规范检验检测市场，完善检验检测体系，指导协调检验检测行业发展。
        </p>
        <p>
            （十四）负责统一管理、监督和综合协调全国认证认可工作。建立并组织实施国家统一的认证认可和合格评定监督管理制度。
        </p>
        <p>
            （十五）负责市场监督管理科技和信息化建设、新闻宣传、国际交流与合作。按规定承担技术性贸易措施有关工作。
        </p>
        <p>
            （十六）管理国家药品监督管理局、国家知识产权局。
        </p>
        <p>
            （十七）完成党中央、国务院交办的其他任务。
        </p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newsDetail.vue